export const COMPANY = 'company';
export const USER = 'user';
